<div class="dash-wrap">
  <div class="dash-card">
    <div class="dash-header">
      <img *ngIf="companyLogo" [src]="companyLogo" alt="company logo" class="dash-logo">
      <div>
        <h1>Welcome{{ userName ? ', ' + userName : '' }}</h1>
        <p *ngIf="companyName" class="dash-sub">{{ companyName }}</p>
        <p *ngIf="email" class="dash-sub dash-sub--muted">{{ email }}</p>
      </div>
    </div>

    <div class="dash-notice">
      This is a minimal landing page, not a reverse-engineered copy of a real dashboard screen —
      none was found anywhere in this project. It exists so a successful login has somewhere real to
      land (see <code>NewLogin_RelatedFile/Login/Login-Test-Report.md</code>). Replace it with your
      actual dashboard whenever you have one.
    </div>

    <div class="dash-actions">
      <a [routerLink]="['/admin']" class="btn btn-outline-info">Go to Admin Console</a>
      <button type="button" class="btn btn-outline-danger" (click)="logout()">Log out</button>
    </div>
  </div>
</div>
